$(document).ready(function(){
  $('.itemList02 h3').matchHeight();
  $('p.price').matchHeight();
  $('.itemListWrap').matchHeight();
  $('.itemDetailsWrap').matchHeight();
  $('p.referencePrice').matchHeight();
  $('li.type').matchHeight();
  $('ul.itemListSpecification').matchHeight();
});
